function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { InternalText, useTextColor } from "../../internal/InternalText";
import { useContext } from 'react';
import { BackgroundContext, LinkContext } from "../../internal";
import { hasSufficientContrast } from "../../utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * **Do not use this for headings** or you will cause accessibility issues.  Use the Heading component instead
 */
export function Text(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    _ref$contrast = _ref.contrast,
    contrast = _ref$contrast === void 0 ? 'high' : _ref$contrast,
    id = _ref.id,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'secondary' : _ref$intent,
    lineClamp = _ref.lineClamp,
    overflow = _ref.overflow,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bodyM' : _ref$variant,
    wordBreak = _ref.wordBreak;
  if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(as)) {
    throw new Error('Do not use Text for headings or you will cause accessibility issues. Use the Heading component instead');
  }
  if (!['span', 'div', 'p'].includes(as)) {
    throw new Error('`as` prop must be one of span, div, or p');
  }
  if (typeof align === 'string' && !['start', 'end', 'center'].includes(align)) {
    throw new Error('`align` prop must be one of start, end, or center');
  }
  if (_typeof(align) === 'object' && Object.keys(align).some(function (key) {
    var value = align[key];
    return typeof value === 'string' && !['start', 'end', 'center'].includes(value);
  })) {
    throw new Error('`align` prop must be one of start, end, or center');
  }
  var _useContext = useContext(BackgroundContext),
    backgroundColor = _useContext.backgroundColor,
    isBackgroundGradient = _useContext.isBackgroundGradient;
  var linkContext = useContext(LinkContext);
  var colorUtil = useTextColor(intent, !!linkContext && isBackgroundGradient ? 'inverted' : contrast);
  if (intent === 'secondary' && !hasSufficientContrast(colorUtil(), backgroundColor)) {
    // NOTE: if you see this error and think this is a false positive please reach out to UIE
    // There is a follow up ticket UIE-2223 to implement BackgroundContext in all components
    throw new Error('There is an accessibility issue; there is not enough contrast between the Text and background color.');
  }
  return _jsx(InternalText, {
    align: align,
    as: as,
    contrast: contrast,
    id: id,
    intent: intent,
    lineClamp: lineClamp,
    overflow: overflow,
    variant: variant,
    wordBreak: wordBreak,
    children: children
  });
}